import { render, staticRenderFns } from "./NotificationView.vue?vue&type=template&id=c37d070e&scoped=true&"
import script from "./NotificationView.vue?vue&type=script&lang=js&"
export * from "./NotificationView.vue?vue&type=script&lang=js&"
import style0 from "./NotificationView.vue?vue&type=style&index=0&id=c37d070e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37d070e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c37d070e')) {
      api.createRecord('c37d070e', component.options)
    } else {
      api.reload('c37d070e', component.options)
    }
    module.hot.accept("./NotificationView.vue?vue&type=template&id=c37d070e&scoped=true&", function () {
      api.rerender('c37d070e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Notifications/NotificationView.vue"
export default component.exports